export default __webpack_public_path__ + "static/media/icons8-unread-messages-right.c624bca5.svg";